<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :beforeSetupGrid="beforeSetupGrid"
            :actions="actions"
            ref="grid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
        ></dx-grid>

        <v-dialog persistent v-model="importDialog" max-width="450">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 pb-2"
                    >Import DOE</v-card-title
                >
                <v-layout row>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        Import
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <div v-if="files.length" class="pt-2 mt-2 ml-2">
                        {{ files[0].name }}
                    </div></v-layout
                >
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept=".csv"
                    @change="onFilePicked($event)"
                />
                <div class="mt-2 mb-1 mx-1">
                    Enter a list of Zip Codes's separated by a comma
                </div>
                <v-textarea
                    class="mx-1 mt-0"
                    label="Zipcodes"
                    v-model="zipcodes"
                    :rules="[rules.zipcode]"
                    outline
                    rows="2"
                    ref="zipcodes"
                ></v-textarea>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeImportDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!files.length"
                        :loading="processing"
                        color="success"
                        @click="importFile()"
                    >
                        import
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="votingDialog" max-width="1000">
            <voting-master-list-person
                :person="presonInfo"
                :reload="reload"
                :close="closeVotingDialog"
            ></voting-master-list-person>
        </v-dialog>
    </div>
</template>

<script>
import votingMasterListPerson from "./VotingMasterListPerson.vue";

export default {
    components: {
        votingMasterListPerson,
    },
    data: () => ({
        title: "DOE",
        processing: false,
        uploading: false,
        url: "",
        actions: [],

        importDialog: false,
        files: [],

        zipcodes: "",

        votingDialog: false,
        presonInfo: {},

        rules: {
            zipcode: (value) => {
                if (!value) return true;

                return value.length >= 5 || `Must be 5 digits`;
            },
        },

        columns: [
            {
                field: "isMatched",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, row) => {
                    return value ? "mdi-check-circle" : "mdi-alert";
                },
                iconColor: (value, row) => {
                    return value ? "success" : "#f35123";
                },
            },
            {
                field: "regID",
                label: "DOE ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "first",
                label: "First",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "mi",
                label: "Middle Name",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "last",
                label: "Last",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "s",
                label: "Gander",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "personID",
                label: "Person ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "parentId",
                label: "Parent Id",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "house",
                label: "House",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "street",
                label: "Street",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "apt",
                label: "Apt",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "city",
                label: "City",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "zip",
                label: "Zip",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "tel",
                label: "Tel",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "isMatched",
                label: "Matched",
                type: "boolean",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "matchID",
                label: "Match ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "matchName",
                label: "Matched To",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "matchType",
                label: "Matched Type",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "matchCount",
                label: "Match Type Count",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "dob",
                label: "DOB",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "party",
                label: "Party",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "council",
                label: "Council",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "dlv",
                label: "DLV",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "datE_REG",
                label: "Date Reg",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "election",
                label: "Election",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "assembly",
                label: "Assembly",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "congress",
                label: "Congress",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "senate",
                label: "Senate",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "civilCourtDistrict",
                label: "Civil Court District",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "judicialDistrict",
                label: "Judicial District",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "statusCode",
                label: "Status Code",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "voterType",
                label: "Voter Type",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "effStatusChangeDate",
                label: "Eff Status Change Date",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "isCurrent",
                label: "Is Current",
                format: "",
                visible: false,
                type: "boolean",
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "voteHistory",
                label: "Voter History",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {},
    methods: {
        beforeSetupGrid() {
            this.actions.push({
                text: "Import",
                action: this.openImportDialog,
            });

            this.url = "doe";
        },
        onRowClicked(row) {
            this.openVotingDialog(row);
        },
        async openVotingDialog(row) {
            if (row.personID == "No Ansl ID" || !row.personID) {
                return this.$notify({
                    group: "notification",
                    text: "No Ansl ID",
                    type: "warning",
                });
            }

            this.presonInfo = await this.$http.get(
                "api/applicantStudents/getPersonByID?personID=" + row.personID,
            );

            this.votingDialog = true;
        },
        closeVotingDialog() {
            this.votingDialog = false;
        },
        reload() {
            this.$refs.grid.reloadGrid();
        },
        openImportDialog() {
            this.importDialog = true;
        },
        pickFile() {
            this.$refs.files.click();
        },
        onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            this.uploading = false;
        },
        closeImportDialog() {
            this.importDialog = false;
            this.files = [];
            this.$refs.files.value = "";
        },
        async importFile() {
            if (!this.$refs.zipcodes.validate(true)) return;

            try {
                this.processing = true;

                var formData = new FormData();

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/doe/Import?user=" +
                        this.$store.state.authentication.user +
                        "&zipcodes=" +
                        this.zipcodes,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.$notify({
                    group: "notification",
                    duration: 10000,
                    text:
                        response.newRecords +
                        " New Records, " +
                        response.updatedRecords +
                        " Updated Records",
                    type: "success",
                });

                this.processing = false;
                this.importDialog = false;
                this.files = [];
                this.$refs.files.value = "";
                this.zipcodes = "";

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style></style>
